<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-btn">
                <el-button
                v-if="isPrimaryKey('POLICYRULE_DELETE')"
                  type="text"
                  @click="deletePolicyRule"
                  :disabled="this.selected.length != 1"
                  >{{$t('common.btn.delete')}}</el-button
                >
                <el-button v-if="isPrimaryKey('POLICYRULE_ADD')" type="text" @click="addPolicyRule"
                  >{{$t('common.btn.add')}}</el-button
                >
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="600px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form ref="form" :model="form">
          <el-form-item
            prop="regulationsTitle"
            :label="$t('GovernmentRegulation.noteTitle')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.regulationsTitle"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item prop="regulationsContent" :label="$t('GovernmentRegulation.regulationsContent')+':'" :label-width="formLabelWidth">
            <el-input
              type="textarea"
              :rows="3"
              size="small"
              v-model="form.regulationsContent"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="filePath"
            :label="$t('GovernmentRegulation.filePath')+':'"
            :label-width="formLabelWidth"
          >
            <input @change="uploadFiles()" id="uploadFile" type="file" style="width:200px;" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{$t('common.btn.cancel')}}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import PolicyRule from "./PolicyRule";
export default PolicyRule;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
